import { inject, Injectable } from '@angular/core';

import { PositionMemberConflict } from '@core/tellent-positions-types';

import { TellentPositionsDataFacade } from './tellent-positions-data.facade';

@Injectable({ providedIn: 'root' })
export class TellentPositionsConflictsService {
  private readonly positionsDataFacade = inject(TellentPositionsDataFacade);

  public findMembersAssignedElsewhere(
    selectedGuids: string[],
    currentPositionGuid: string,
  ): PositionMemberConflict[] {
    const memberConflictMap = new Map<string, PositionMemberConflict>();
    const positions = this.positionsDataFacade.positionsData();

    for (const position of positions) {
      if (position.guid === currentPositionGuid) continue;
      for (const member of position.members ?? []) {
        memberConflictMap.set(member.guid, { member, currentPosition: position });
      }
    }

    return selectedGuids
      .map(guid => memberConflictMap.get(guid))
      .filter(entry => entry !== undefined);
  }
}
